import { OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppComponent } from '../app/app.component';

export abstract class BaseRouteComponent implements OnInit {
    protected constructor(protected route: ActivatedRoute, protected app: AppComponent) {}

    ngOnInit(): void {
        const segments = this.route.snapshot.url;

        if (!segments || segments.length === 0) {
            window.scrollTo(0, 0);
            return;
        }

        if (segments[1]) {
            this.app.scroll(segments[1].path);
        } else {
            window.scrollTo(0, 0);
        }
    }
}



// WEBPACK FOOTER //
// /Users/masonpimentel/Repos/mason-blog/src/shared/base-route.component.ts